<template>
  <md-toolbar
    :class="{ 'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute }"
    md-elevation="16"
    style="height: 50px"
    align="Center"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-list>
          <md-list-item href="#" @click="showSwal('logout-confirmation')">
            <!--/reading-center-->
            <i class="material-icons">exit_to_app</i>
            <p class="hidden-sm">&nbsp;Logout</p>
          </md-list-item>
        </md-list>

        <md-button
          :class="{ toggled: $sidebar.showSidebar }"
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          @click="toggleSidebar"
        >
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>
      </div>
    </div>

    <modal v-if="smallAlertModal" m-container="modal-container-small" @close="smallAlertModalHide">
      <template slot="header">
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="smallAlertModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>Are you sure you want to do this?</p>
      </template>

      <template slot="footer">
        <md-button class="md-simple" @click="smallAlertModalHide">Never Mind</md-button>
        <md-button class="md-success md-simple">Yes</md-button>
      </template>
    </modal>
  </md-toolbar>
</template>

<script>
import Swal from "sweetalert2"
import { Modal } from "@/components"
import $ from "jquery"
export default {
  components: {
    Modal
  },
  data() {
    return {
      selectedEmployee: "",
      employees: [],
      smallAlertModal: false
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    showSwal(type) {
      if (type === "logout-confirmation") {
        Swal.fire({
          title: "LOGOUT",
          text: `Are you sure you want to logout?`,
          //type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$store.dispatch("auth/logout").then(() => {
              sessionStorage.clear()
              this.$router.push({ path: "/" })
            })
          }
        })
      }
    },
    smallAlertModalHide: function() {
      this.smallAlertModal = false
    }
  }
}
</script>
